import React, { useEffect } from 'react';
import logo from '../../assets/image/logo-sinFondo.png';

const Loader = ({ isLoading }) => {
  useEffect(() => {
    if (isLoading) {
      window.scrollTo(0, 0);
    }
  }, [isLoading]);

  return (
    isLoading && (
      <div className="fixed inset-0 bg-gradient-to-br from-gray-100 via-gray-200 to-gray-300 flex items-center justify-center z-50">
        
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%236b7280' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='1'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }}></div>
        </div>

        <div className="relative flex flex-col items-center">
          
          {/* Logo con efecto de latido */}
          <div className="relative mb-8">
            {/* Ondas de pulso */}
            <div className="absolute inset-0 animate-ping">
              <div className="w-32 h-32 bg-gray-400 rounded-full opacity-20"></div>
            </div>
            <div className="absolute inset-0 animate-pulse">
              <div className="w-32 h-32 bg-gray-500 rounded-full opacity-10"></div>
            </div>
            
            {/* Logo principal */}
            <div className="relative w-32 h-32 flex items-center justify-center">
              <img
                src={logo}
                alt="Cargando..."
                className="w-24 h-auto transform transition-transform duration-300 heartbeat drop-shadow-lg"
              />
            </div>
          </div>

          {/* Texto de carga */}
          <div className="text-center">
            <h3 className="text-xl font-semibold text-gray-800 mb-2 animate-pulse">
              Cargando vehículos...
            </h3>
            
            {/* Puntos animados */}
            <div className="flex justify-center space-x-1">
              <div className="w-2 h-2 bg-gray-600 rounded-full animate-bounce"></div>
              <div className="w-2 h-2 bg-gray-600 rounded-full animate-bounce" style={{animationDelay: '0.1s'}}></div>
              <div className="w-2 h-2 bg-gray-600 rounded-full animate-bounce" style={{animationDelay: '0.2s'}}></div>
            </div>
          </div>
        </div>

        {/* Estilos CSS en línea para la animación de latido */}
        <style jsx>{`
          .heartbeat {
            animation: heartbeat 1.5s ease-in-out infinite;
          }
          
          @keyframes heartbeat {
            0% {
              transform: scale(1);
            }
            25% {
              transform: scale(1.1);
            }
            50% {
              transform: scale(1);
            }
            75% {
              transform: scale(1.05);
            }
            100% {
              transform: scale(1);
            }
          }
        `}</style>
      </div>
    )
  );
};

export default Loader;